<template>
	<section class="popup_wrap" style="display: block">
		<div class="login_box pay_box">
			<div class="corner-top"></div>
			<div class="popup_close stay_close close-animate">
				<a href="javascript:void(0);" @click.prevent="closePop(false)">
					<CLOSE />
				</a>
			</div>
			<div class="title_has_svg">
				<PASSWORD />
				<h2 class="title center">שחזור סיסמה</h2>
			</div>
			<div class="login_inner">
				<div class="pass-st1" v-if="stage == 1">
					<div class="password_text">
						מה צריך לעשות?
						<br />לכתוב את המייל או הטלפון שאיתו נרשמת לאתר, להגיד
						שלוש פעמים אנטיפסטי ו-הופ! יישלח אליך קישור לאיפוס
						הסיסמה
					</div>
					<form
						action="post"
						name="passresetform"
						@submit.prevent="passwordResetSend"
						method="post"
					>
						<div class="form_input">
							<input
								v-validate="{
									rules: {
										required: this.isEmailRequired,
										email: true,
									},
								}"
								name="email"
								type="text"
								v-model="email"
								placeholder="המייל שלי"
								data-vv-validate-on="none"
							/>
							<div class="error_tx" v-if="errors.first('email')">
								{{ errors.first("email") }}
							</div>

							<p class="or-separator">או</p>

							<input
								v-validate="{
									rules: {
										required: this.isPhoneRequired,
										regex: this.phoneRegex,
									},
								}"
								name="reset_pass_phone"
								type="tel"
								v-model="phone"
								placeholder="הטלפון שלי"
								data-vv-validate-on="none"
							/>
							<div
								class="error_tx"
								v-if="errors.first('reset_pass_phone')"
							>
								{{ errors.first("reset_pass_phone") }}
							</div>
							<div class="error_tx" v-if="this.error">
								{{ this.error }}
							</div>
						</div>
						<div class="submit_bt ease">
							<input type="submit" value="איפוס סיסמה" />
						</div>
					</form>
				</div>

				<div class="pass-st2" v-if="stage == 2">
					<div class="ok-thank">
						<OK />
					</div>
					<div class="password_text">
						<b
							>שלחנו לך קישור לאיפוס הסיסמה, הוא בטח כבר מחכה לך
							במייל או בטלפון.</b
						>
						<br />
						<br />אם לא מצאת את המייל בלשונית הראשית, הוא יכול להגיע
						לפעמים לספאם או ללשונית ה-promotions.
					</div>
				</div>

				<div class="pass-st3" v-if="stage == 3">
					<div class="password_text">הזנת סיסמה</div>
					<div class="clearfix">
						<div class="form_tx">סיסמא חדשה</div>
						<div class="form_input">
							<input type="password" />
							<span class="eye">
								<EYE />
							</span>
						</div>
					</div>
					<div class="clearfix">
						<div class="form_tx">סיסמא בשנית</div>
						<div class="form_input">
							<input class="error" type="password" />
							<span class="eye">
								<EYE />
							</span>
							<span class="input-ok">
								<OK />
							</span>
							<div class="error_tx">הסיסמא שמילאת אינה תואמת</div>
						</div>
					</div>
					<div class="submit_bt ease">
						<input type="submit" value="עדכון סיסמה" />
					</div>
				</div>
				<div class="pass-st4" v-if="stage == 4">
					<div class="ok-thank">
						<OK />
					</div>
					<div class="password_text">
						<b>תודה, סיסמתך עודכנה בהצלחה!</b>
					</div>
					<div class="bt_border ease">
						<a href="#" @click.prevent="closePop(true)"
							>ועכשיו, בחזרה לעמוד הבית</a
						>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import CLOSE from "../../assets/img/close.svg";
	import PASSWORD from "../../assets/img/password.svg";
	import OK from "../../assets/img/ok.svg";
	import EYE from "../../assets/img/eye.svg";
	export default {
		name: "ForgotPassword",
		data() {
			return {
				stage: "1",
				email: "",
				phone: "",
				error: "",
				phoneRegex:
					/^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))(?:\s|\.|-)?([1-9]\d?))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?([^0\D]{1}\d{2}(?:\s|\.|-)?\d{4})$/,
			};
		},
		mounted() {
			this.stage = "1";
		},
		methods: {
			closePop: function (red) {
				this.$modal.hide("password-modal");
				if (red && this.$route.name != "checkout") {
					this.$router.push("/");
				}
			},
			passwordResetSend: function () {
				this.$validator.validate().then((result) => {
					if (result) {
						let form = document.querySelector(
							"form[name=passresetform]"
						);
						let data = new FormData(form);
						$(form).find(".submit_bt").addClass("proccessing");
						if (this.email === "" && this.phone) {
							this.submitResetPasswordViaSMS();
							return;
						}
						this.$ajax
							.post(
								this.$wpData.home_url +
									"?sendForgot&email=" +
									this.email
							)
							.then((res) => {
								if (res.data.return == "Fine") {
									this.stage = 2;
									$(form)
										.find(".submit_bt")
										.removeClass("proccessing");
								} else {
									this.error = res.data.returnTxt;
									$(form)
										.find(".submit_bt")
										.removeClass("proccessing");
								}
							});
					}
				});
			},
			submitResetPasswordViaSMS: function () {
				this.$ajax
					.get(
						this.$wpData.home_url +
							"?resetPasswordBySMS&phone=" +
							this.phone
					)
					.then((res) => {
						if (res.data.return == "Fine") {
							this.stage = 2;
							$(form)
								.find(".submit_bt")
								.removeClass("proccessing");
						} else {
							this.error = res.data.returnTxt;
							$(form)
								.find(".submit_bt")
								.removeClass("proccessing");
						}
					});
			},
		},
		computed: {
			isPhoneRequired() {
				return this.email === "";
			},
			isEmailRequired() {
				return this.phone === "";
			},
		},
		components: {
			CLOSE,
			PASSWORD,
			OK,
			EYE,
		},
	};
</script>

<style lang="sass" scoped>

	.login_box
		transform: translate(0%, 30%)

	.or-separator
		text-align: center
		padding: 1rem 0
		display: flex
		justify-content: center
		align-items: center
		gap: 0.5rem
		&:before, &:after
			content: ''
			width: 1rem
			height: 2px
			background-color: #c5c5c5
</style>
